import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Navbar } from "./components/site/Navbar";
import { Hero } from "./components/site/Hero";
import { CompanySnapshot } from "./components/site/CompanySnapshot";
import { About } from "./components/site/About";
import { WhyWeExist } from "./components/site/WhyWeExist";
import { WhatWeDo } from "./components/site/WhatWeDo";
import { InvestmentApproach } from "./components/site/InvestmentApproach";
import { Focus } from "./components/site/Focus";
import { Opportunity } from "./components/site/Opportunity";
import { Trust } from "./components/site/Trust";
import { FAQ } from "./components/site/FAQ";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { LegalPage } from "./pages/LegalPage";

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 120);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <div className="App bg-[#F4F3EF] text-[#1A1C19] antialiased">
      <Navbar />
      <main>
        <Hero />
        <CompanySnapshot />
        <About />
        <WhyWeExist />
        <WhatWeDo />
        <InvestmentApproach />
        <Focus />
        <Opportunity />
        <Trust />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<LegalPage docKey="privacy" />} />
          <Route path="/terms" element={<LegalPage docKey="terms" />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
